import React from 'react';

import type { IStar } from '../../../models';

import { PaleStar } from './pale-star';
import { FilledStar } from './filled-star';
import { DashedStar } from './dashed-star';
import { EmptyStar } from './empty-star';

export const Star = ({
    dataTestId,
    isChecked,
    isIncreasing,
    isPreChecked,
    key,
    onClick,
    onMouseEnter,
}: IStar) => {
    if (!isChecked) {
        return isPreChecked ? (
            <DashedStar
                key={key}
                dataTestId={dataTestId}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
            />
        ) : (
            <EmptyStar
                key={key}
                dataTestId={dataTestId}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
            />
        );
    }
    if (!isPreChecked || isIncreasing) {
        return (
            <FilledStar
                key={key}
                dataTestId={dataTestId}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
            />
        );
    }

    return (
        <PaleStar key={key} dataTestId={dataTestId} onClick={onClick} onMouseEnter={onMouseEnter} />
    );
};
